<script setup lang="ts">
import DeleteButton from "@/components/DeleteButton.vue";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import EditLink from "@/components/links/EditLink.vue";
import StatsList from "@/components/StatsList.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { useGetStats } from "@/stats/useStats";
import { Plus, Trash } from "@iconoir/vue";
import { pick } from "lodash-es";
import { computed } from "vue";
import { RouterLink } from "vue-router";
import { userRoles } from "./roles";
import { useDeleteUser, useGetUsers } from "./usersCrud";

const { users, getUsersStatus } = useGetUsers();
const { deleteUser, resetDeleteUser, deleteUserStatus } = useDeleteUser();

const { stats, getStatsStatus } = useGetStats();
const userStats = computed(() => {
  if (!stats.value) return undefined;
  return pick(stats.value, ["totalUsers"]);
});
</script>

<template>
  <ManagementLayout>
    <template #header>
      <div class="column">
        <h1>Nutzer:innen</h1>
        <HandleQueryStatus :query-status="getStatsStatus">
          <StatsList v-if="userStats !== undefined" :stats="userStats" />
        </HandleQueryStatus>
        <RouterLink :to="{ name: 'invitations' }" class="button" role="button">
          <Plus /> Nutzer:in einladen
        </RouterLink>
      </div>
    </template>
    <HandleQueryStatus :query-status="getUsersStatus">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>E-Mail</th>
            <th>Rolle</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>
              <RouterLink
                :to="{
                  name: 'editUser',
                  params: { id: user.id },
                }"
                class="column--primary-action"
              >
                {{ user.name }}
              </RouterLink>
            </td>
            <td>{{ user.email }}</td>
            <td>{{ userRoles[user.role] }}</td>
            <td class="actions">
              <EditLink :to="{ name: 'editUser', params: { id: user.id } }">
                Bearbeiten
              </EditLink>
              <DeleteButton
                class="button button--tertiary"
                :deleting-status="deleteUserStatus"
                @initiated="resetDeleteUser()"
                @confirmed="deleteUser(user)"
              >
                <Trash />
                <span class="visually-hidden"> Löschen </span>
                <template #confirmation>
                  Möchtest du die:den Nutzer:in "{{ user.name }}" wirklich
                  löschen?
                </template>
              </DeleteButton>
            </td>
          </tr>
        </tbody>
      </table>
    </HandleQueryStatus>
  </ManagementLayout>
</template>
